import { create } from "@bufbuild/protobuf";
import { createConnectQueryKey, useQuery, UseQueryOptions } from "@connectrpc/connect-query";

import {
  GetTenantPlanRequest,
  GetTenantPlanRequestSchema,
  GetTenantPlanResponse,
  GetTenantUsageRequest,
  GetTenantUsageRequestSchema,
  GetTenantUsageResponse,
} from "@gx/ts-contracts/services/management/api/tenant_plan_pb";
import {
  getTenantPlan,
  getTenantUsage,
} from "@gx/ts-contracts/services/management/api/tenant_plan-TenantPlanService_connectquery";

// ========== GET TENANT PLAN ==========

export const createGetTenantPlanQueryKey = (input?: GetTenantPlanRequest) => {
  return createConnectQueryKey({
    schema: getTenantPlan,
    input,
    cardinality: "finite",
  });
};

export const useGetTenantPlanQuery = ({
  input = create(GetTenantPlanRequestSchema, {}),
  options = {},
}: {
  input?: GetTenantPlanRequest;
  options?: UseQueryOptions<typeof getTenantPlan.output, GetTenantPlanResponse>;
}) => {
  return useQuery<typeof getTenantPlan.input, typeof getTenantPlan.output>(
    getTenantPlan,
    input,
    options,
  );
};

// ========== GET TENANT USAGE ==========

export const createGetTenantUsageQueryKey = (input?: GetTenantUsageRequest) => {
  return createConnectQueryKey({
    schema: getTenantUsage,
    input,
    cardinality: "finite",
  });
};

export const useGetTenantUsageQuery = ({
  input = create(GetTenantUsageRequestSchema, {}),
  options = {},
}: {
  input?: GetTenantUsageRequest;
  options?: UseQueryOptions<typeof getTenantUsage.output, GetTenantUsageResponse>;
}) => {
  return useQuery<typeof getTenantUsage.input, typeof getTenantUsage.output>(
    getTenantUsage,
    input,
    options,
  );
};
